import { createTheme, CssBaseline, useMediaQuery } from '@mui/material';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import routes from './route';
import SocialLinks from './ui/common/social/social';
import Notfound from './ui/components/notFound/notfound';
import { Hidden } from '@mui/material';
import { ScrollToTop } from 'react-router-scroll-to-top';
import Aurora from './ui/common/bits/aurora';
import DotGrid from './ui/common/bits/dot-grid';

function App() {
  const theme = useTheme()
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const light_theme = ["#66FF8C", "#FFF", "#da581c"];
  const dark_theme = ["#66FF8C", "#dddb48", "#da581c"];

  const colorMode = React.useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            light: "#B9EDE4",
            main: "#e9803b",
            dark: "#069F7B",
            contrastText: "#004233",
          },
          secondary: {
            light: "#BFC3C5",
            main: "#2B363E",
            dark: "#10161B",
            contrastText: "#BFC3C5",
          },
          mode: prefersDarkMode ? "dark" : "dark",
        },
      }),
    [prefersDarkMode]
  );
  return (
    <ThemeProvider theme={theme}>
      <ThemeProvider theme={(outerTheme) => ({ ...outerTheme, ...colorMode })}>
        <CssBaseline />

        <BrowserRouter>
          <ScrollToTop />
          <Switch>
              <div className="ui-bg"> 
              {/* <div style={{ width: "100%", height: "100%", position: "absolute", zIndex: 0 }}>
                <DotGrid dotSize={10} gap={15} baseColor="#5227FF" activeColor="#5227FF" proximity={120} shockRadius={250} shockStrength={5} resistance={750} returnDuration={1.5} />
              </div> */}
              {/*   */}
              <Hidden mdDown>
                <div className="social-links">
                  <SocialLinks displayType="vertical"></SocialLinks>
                </div>
              </Hidden>
              {routes.map((route, index) => {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    component={(props: any) => {
                      // console.log(route, index);
                      if (!route) {
                        return <Route component={Notfound} />;
                      } else {
                        return <route.component {...props} />;
                      }
                    }}
                  />
                );
              })}
            </div>
          </Switch>
        </BrowserRouter>
      </ThemeProvider>
    </ThemeProvider>
  );
}

export default App;
